module.exports = __webpack_public_path__ + "img/zhenwen.d95ab24d.jpg";